import React from "react";
import Seo from "../components/seo";
import Layout from "../components/layout";
import SectionNav from "../components/newComponents/sectionNav";
import SectionHead from "../components/newComponents/sectionHead";
import Card from "../components/newComponents/card";
import { useParams } from "react-router";
import { useQuery } from "@apollo/client";
import { HandleQuery, WhatWeDoTeamData } from "../queries";

export function WhatWeDoTeamEntry()
{
    let { slug } = useParams();

    const query_state = useQuery(WhatWeDoTeamData(slug), {fetchPolicy: 'no-cache'});
    const { complete, view } = HandleQuery(query_state);
    if(!complete) return view;
    const data = query_state.data; 

    return(
  <Layout>
    <Seo title={data.entry[0].title} />
    <div className="main">
      <SectionNav data={data} base={`/what-we-do/${slug}`} currentUri={`/what-we-do/${slug}/team`}/>
      <section className="section-overview" style={{paddingBottom: 0}}>
          <div className="shell">
          <SectionHead title={data.entry[0].title} subtitle={"Meet the team"}/>
            </div>
        </section>
      <section className="section-boxes" style={{paddingTop: 0}}>
        <div className="shell">
          
          <div className="boxes js-slider-boxes swiper-container">
            <ul>
              {data.entry[0].relatedTeamMembers.length > 0 ?
                data.entry[0].relatedTeamMembers.filter((item) => {return item.status == "live"}).map((item, i) => (
                  <Card 
                    isStaff={true}
                    key={`what-we-do-team-entry-${i}`} 
                    image={item.featureImage[0]}
                    ar={1/1} 
                    hasFocalPoint={item.featureImage.length > 0 ? item.featureImage[0].hasFocalPoint : false}
                    title={item.displayTitle} 
                    subtitle={item.position} 
                    href={item.bodyContent.length > 0 && `/${item.uri}`} 
                    color={2}
                  />
                ))
                :
                <li className="box">No content found.</li>
              }
            </ul>
          </div>
        </div>
      </section>
    </div>
  </Layout> 
);
}
